









































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { AgencySettingsModule } from "@/store/modules/agencySettings";
import { AppModule } from "@/store/modules/app";
import { AgencyDashboardModule } from "@/store/modules/agencyDashboard";
import BranchDto from "@/models/Branches/BranchDto";

@Component({
  name: "DashboardBookingRolesSearchCriteria",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  public locationSearch: any = null;
  public datesFailedValidation = false;

  allowedDates(date: Date) {
    return new Date(date).getDay() === 1;
  }

  @Watch('searchOptions.selectedBranch')
  async onDefaultBranchChanged(val: BranchDto, oldVal: BranchDto) {
    if (!val) {
      this.searchOptions.selectedDesk = null;
    }
  } 

  get searchOptions() {
    return AgencyDashboardModule.filterBookingRoleStatisticsViewModel;
  }
  get currentSearchCriteria() {
    return AgencyDashboardModule.currentStatisticsSearchCriteria;
  }

  get weekCommencing() {
    const dateStr = AgencyDashboardModule.currentStatisticsSearchCriteria.startAtFrom;
    const dArr = dateStr.split("-");  // ex input "2010-01-18"
    return dArr[2]+ "/" +dArr[1]+ "/" +dArr[0].substring(2); //ex out: "18/01/10"
  }

  get desks() {
    if (this.searchOptions.selectedBranch) {
        return this.searchOptions.selectedBranch.desks;
    }
    return [];
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get loading() {
    return AgencyDashboardModule.loading;
  }

  async search() {
    if (AgencyDashboardModule.filterBookingRoleStatisticsViewModel.startAtFrom === undefined) {
      this.datesFailedValidation = true;
      return;
    }
    this.dialog = false;
    await AgencyDashboardModule.getBookingRoleStatistics();
  }
}
